import { useEffect } from 'react';

export default function HelpPanel({ title, onClose, children }) {
  // Close on Escape
  useEffect(() => {
    function onKey(e) {
      if (e.key === 'Escape') onClose();
    }
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="fixed right-0 top-0 h-full w-full sm:w-[460px] bg-white shadow-[-4px_0_20px_rgba(0,0,0,0.10)] z-30 flex flex-col">
      <div className="px-5 py-3 border-b border-n-200 flex items-center justify-between shrink-0">
        <span className="text-sm font-semibold text-n-800">{title}</span>
        <button
          onClick={onClose}
          className="text-n-400 hover:text-n-600 p-1 rounded"
          aria-label="Close help"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
      <div className="flex-1 overflow-y-auto px-5 py-4 text-sm text-n-700 space-y-6">
        {children}
      </div>
    </div>
  );
}

// ── Shared content primitives ─────────────────────────────────────────────────

export function H2({ children }) {
  return (
    <h2 className="text-xs font-semibold uppercase tracking-wide text-n-400 mt-2">{children}</h2>
  );
}

export function H3({ children }) {
  return <h3 className="font-semibold text-n-800 mt-1">{children}</h3>;
}

export function P({ children }) {
  return <p className="text-sm text-n-600 leading-relaxed">{children}</p>;
}

export function HelpTable({ headers, rows }) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-xs border-collapse">
        <thead>
          <tr className="bg-n-50">
            {headers.map((h) => (
              <th
                key={h}
                className="px-3 py-2 text-left font-medium text-n-600 border border-n-200"
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i} className={i % 2 === 0 ? 'bg-white' : 'bg-n-50'}>
              {row.map((cell, j) => (
                <td key={j} className="px-3 py-2 text-n-700 border border-n-200 align-top">
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
